import {useEffect, useState} from 'react';
import {GuidesEnum} from 'presentation/constants';
import {useLocation, useNavigate} from 'react-router-dom';
import {useMediaQueries} from 'presentation/pages';
import {useChangeDataFormStateStore} from 'presentation/pages/private/profile/store/changeDataFormStateStore';
import {HealthGuideFavoritePlaceItem} from '../types';
import {AddressDataFormValues} from 'presentation/components/ChangeData/Address/AddressForm/validation';
import {usePatchFavoritePlaceMutation} from '../mutations/usePatchFavoritePlaceMutation';

export function useEditFavoritePlace() {
  const [openEditFavoritePlaceSuccess, setOpenEditFavoritePlaceSuccess] = useState(false);
  const [openEditFavoritePlaceError, setOpenEditFavoritePlaceError] = useState(false);
  const {isMobile, isTablet} = useMediaQueries();
  const navigate = useNavigate();
  const {state: routeState} = useLocation();
  const setChangeDataFormState = useChangeDataFormStateStore(state => state.updateFormState);
  const {
    mutate: patchFavoritePlace,
    isPending: isPatchingFavoritePlace,
    isSuccess: isPatchingFavoritePlaceSuccess,
    isError: isPatchingFavoritePlaceError,
  } = usePatchFavoritePlaceMutation();

  const handleBack = () => {
    setChangeDataFormState({
      isFormActive: false,
      isFormDirty: false,
    });
    navigate(routeState?.from || GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_LIST);
  };

  const handleOpenFavoritePlaceSuccess = () => {
    setOpenEditFavoritePlaceSuccess(true);
  };

  const handleCloseFavoritePlaceSuccess = () => {
    setOpenEditFavoritePlaceSuccess(false);
    navigate(GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_LIST);
  };

  const handleOpenEditFavoritePlaceError = () => {
    setOpenEditFavoritePlaceError(true);
  };

  const handleCloseEditFavoritePlaceError = () => {
    setOpenEditFavoritePlaceError(false);
  };

  useEffect(() => {
    if (isPatchingFavoritePlaceSuccess) {
      handleOpenFavoritePlaceSuccess();
    } else if (isPatchingFavoritePlaceError) {
      handleOpenEditFavoritePlaceError();
    }
  }, [isPatchingFavoritePlaceSuccess, isPatchingFavoritePlaceError]);

  const onSubmit = async (data: AddressDataFormValues) => {
    patchFavoritePlace({
      cdBeneficiarioEnderecoFavorito: Number(
        routeState?.item?.address.cdBeneficiarioEnderecoFavorito,
      ),
      data,
    });
  };

  const isMobOrTab = isMobile || isTablet;

  const favoritePlaceToAddressFormParser = (item: HealthGuideFavoritePlaceItem | null) => {
    if (!item) return null;
    const {nmLocal} = item.address;
    const nmTipoLogradouro = item.address.nmLogradouro.split(' ')[0];
    const nmRua = item.address.nmLogradouro.split(' ').slice(1).join(' ');
    return {
      favoriteAddress: nmLocal,
      cdUsuario: '',
      cdEnderecoCorrespondencia: 1,
      cdEnderecoCorrespondenciaUt: 1,
      nmTipoLogradouro: nmTipoLogradouro,
      nmRua: nmRua,
      dsPontoReferencia: '',
      flTipoEndereco: '',
      dsComplemento: item.address?.dsComplemento || '',
      ...item.address,
    };
  };

  const item = routeState?.item ? favoritePlaceToAddressFormParser(routeState.item) : null;

  return {
    isMobOrTab,
    handleBack,
    onSubmit,
    openEditFavoritePlaceSuccess,
    handleCloseFavoritePlaceSuccess,
    openEditFavoritePlaceError,
    handleCloseEditFavoritePlaceError,
    isPatchingFavoritePlace,
    item,
  };
}
